import Vue from 'vue'
import Vuex from 'vuex'
// import Chat from './Chat/index'
import Account from './Account'
import Auth from './Auth'
import MedicalAppointment from './MedicalAppointment'
import Notification from './Notification'
import Patient from './Patient'
import PatientCare from './PatientCare'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    Auth,
    Account,
    // Chat,
    MedicalAppointment,
    Patient,
    Notification,
    PatientCare
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  strict: debug
})
